import { Injectable, inject } from '@angular/core';
import { collection, Firestore, getDocs, query, where } from 'firebase/firestore';
import { FIREBASE_FIRESTORE } from '@pedix-workspace/angular-firebase';
import { BehaviorSubject } from 'rxjs';
import {
  Establishment, reservedSlugWords
} from '@pedix-workspace/utils';

@Injectable({
  providedIn: 'root',
})
export class SlugService {
  establishmentsSubject = new BehaviorSubject<{ [slug: string]: Establishment | null }>({});

  private firestore = inject(FIREBASE_FIRESTORE);

  constructor() {}

  async isSlugAvailable(slug: string) {
    if (reservedSlugWords.includes(slug)) {
      return false;
    }

    const q = query(collection(this.firestore, 'establishments'), where("slug", "==", slug));
    const results = await getDocs(q);

    return results.empty === true;
  }
}
